export const STREAM_ID_PARAM = 'streamId';
//# sourceMappingURL=consts.js.map